import React from 'react';
import { ArrowLeftOutlined, CheckCircleOutlined, LoadingOutlined } from '@ant-design/icons';
import { Button, Card, Empty, Form, Input, Select, Space, Spin, Steps, Typography } from 'antd';
import ImagePicker from 'components/pickers/image/Image';
import MultiImagePicker from 'components/pickers/image/MultiImagePicker';

const { Text, Title } = Typography;

const Mobile = ({ viewModel }) => {
  const {
    form,
    draftValues,
    step,
    loading,
    submitting,
    workspace,
    result,
    isDemo,
    industryOptions,
    nextStep,
    prevStep,
    onValuesChange,
    submit,
    goBack,
    openWebsite,
  } = viewModel;

  if (!loading && !isDemo) {
    return <Empty description='Chỉ hỗ trợ thiết lập website cho shop demo' />;
  }

  return (
    <Spin spinning={loading}>
      <div style={{ display: 'grid', gap: 10 }}>
        <Button icon={<ArrowLeftOutlined />} onClick={goBack}>Quay lại</Button>

        <Card>
          <Title level={5} style={{ marginTop: 0 }}>Thiết lập website demo bằng AI</Title>
          <Steps
            current={step}
            direction='vertical'
            size='small'
            items={[
              { title: 'Thông tin shop' },
              { title: 'Logo & ảnh sản phẩm' },
              { title: 'Thiết lập AI' },
              { title: 'Hoàn tất' },
            ]}
          />
        </Card>

        <Card>
          <Form form={form} layout='vertical' preserve onValuesChange={onValuesChange} initialValues={draftValues || {}}>
            {step === 0 && (
              <>
                <Form.Item label='Tên shop' name='shop_name' rules={[{ required: true, message: 'Vui lòng nhập tên shop' }]}>
                  <Input />
                </Form.Item>
                <Form.Item label='Ngành hàng' name='industry' rules={[{ required: true, message: 'Vui lòng chọn ngành hàng' }]}>
                  <Select options={industryOptions} />
                </Form.Item>
                <Form.Item label='Mô tả mong muốn' name='description'>
                  <Input.TextArea rows={4} />
                </Form.Item>
              </>
            )}

            {step === 1 && (
              <>
                <Form.Item label='Logo shop (nếu có)' name='logo_image'>
                  <ImagePicker />
                </Form.Item>
                <Form.Item label='Ảnh sản phẩm (AI sẽ phân tích)' name='product_images'>
                  <MultiImagePicker maxPhotos={10} />
                </Form.Item>
              </>
            )}

            {step === 2 && (
              <div style={{ textAlign: 'center', padding: '20px 0' }}>
                <LoadingOutlined style={{ fontSize: 28 }} />
                <div style={{ marginTop: 8 }}>
                  <Text>AI sẽ tự tạo website mẫu, sản phẩm và giá demo.</Text>
                </div>
              </div>
            )}

            {step === 3 && (
              <Space direction='vertical' size={10} style={{ width: '100%' }}>
                <Space>
                  <CheckCircleOutlined style={{ color: '#52c41a' }} />
                  <Text strong>Thiết lập thành công</Text>
                </Space>
                <Text>Đã tạo {result?.products_created?.length || 0} sản phẩm mẫu.</Text>
                <Button block onClick={openWebsite}>Mở website</Button>
                <Button block onClick={goBack}>Về chi tiết shop</Button>
              </Space>
            )}
          </Form>
        </Card>

        {step < 3 && (
          <Card>
            <Space style={{ width: '100%', justifyContent: 'space-between' }}>
              <Button onClick={prevStep} disabled={step === 0}>Quay lại</Button>
              {step < 2 ? (
                <Button type='primary' onClick={nextStep}>Tiếp tục</Button>
              ) : (
                <Button type='primary' loading={submitting} onClick={submit}>Bắt đầu thiết lập</Button>
              )}
            </Space>
          </Card>
        )}

        {step === 3 && workspace?.web_site?.url && (
          <Card title='Xem trước website'>
            <iframe
              title='website-preview-mobile'
              src={`https://${workspace.web_site.url}.sipro.store`}
              style={{ width: '100%', height: 560, border: '1px solid #f0f0f0', borderRadius: 8 }}
            />
          </Card>
        )}
      </div>
    </Spin>
  );
};

export default Mobile;
